function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

import FlowFactory from 'edge/platform/flow/FlowFactory';
import routerStepChangeListener from './angularhelpers/RouterStepChangeListener';
import cancelConfirmation from './angularhelpers/CancelConfirmation';
import actionStatusMessages from './angularhelpers/ActionStatusMessages';
import snapshotResetConfirmation from './angularhelpers/SnapshotResetConfirmation';
import 'gw-portals-tracking-angular';

export default ['$q', '$state', 'StateUtils', 'ModalService', 'EventHub', function ($q, $state, StateUtils, ModalService, EventHub) {
    /**
     *  Angular service to wrap FlowFactory and set dependencies that are specific to use in a wizard context.
     *  For example provides a stepChange listener that hooks into ui-router and transitions to a new page for each
     *  transition to a step or exit junction.
     *  The flow model object returned from the FlowFactory.get call is stored in the base wizard state object.
     *  Here it can be accessed by components like the NavBar that are not under the wizard component.
     *
     * @param {Function} flowDefn - flow definition function
     *
     * @param {String} parentWizardState - The parent state which all wizard pages are children
     *
     * @param {Object} [stepToStateMapping] - Mapping from a step name to a function that handles a transition to a router state
     *                                       This function overrides the default mapping of what routing behavior to do
     *                                       after moving to a new step in the flow.
     * @param {*} [eventListeners]
     *
     * @returns {Object}
     */
    return function (flowDefn, parentWizardState, stepToStateMapping, eventListeners) {
        var routerListenerFn = routerStepChangeListener($state, StateUtils, parentWizardState, stepToStateMapping);

        var modalBehavior = {
            actionStatusInfo: actionStatusMessages(ModalService),
            snapshotResetConfirmation: snapshotResetConfirmation(ModalService, $q),
            cancelConfirmation: cancelConfirmation(ModalService, StateUtils)
        };

        function storeModelAndFlow(_model, _flow) {
            // flowModel is accessible globally from base wizard state object
            var wizardStateData = StateUtils.dataForState(parentWizardState);
            wizardStateData.flowModel = _flow;
            wizardStateData.model = _model;
        }

        var listeners = angular.isDefined(eventListeners) ? [routerListenerFn].concat(_toConsumableArray(eventListeners)) : [routerListenerFn];
        var factory = FlowFactory.get($q, EventHub, listeners, modalBehavior, StateUtils);

        var flowInstance = factory(flowDefn);
        return {
            start: function start(model, extraArgs) {
                var flowModel = flowInstance.start(model, extraArgs);
                storeModelAndFlow(model, flowModel);
                return flowModel;
            },
            resume: function resume(model, extraArgs) {
                var flowModel = flowInstance.resume(model, extraArgs);
                storeModelAndFlow(model, flowModel);
                return flowModel;
            }
        };
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/flow/WizardFlowService.js
// module id = 751
// module chunks = 0